export const ASPECT_RATIOS = ['1:1', '4:5', '16:9', '9:16'] as const;

export type AspectRatio = (typeof ASPECT_RATIOS)[number];

export interface AspectRatioMeta {
  readonly label: string;
  readonly width: number;
  readonly height: number;
  readonly usage: string;
}

/**
 * Aspect ratios are configuration data, never hardcoded in services or UI.
 * `width`/`height` are the canonical render dimensions (scaled by providers).
 */
export const ASPECT_RATIO_META: Record<AspectRatio, AspectRatioMeta> = {
  '1:1': { label: 'Square 1:1', width: 1080, height: 1080, usage: 'Feed / OG / thumbnail' },
  '4:5': { label: 'Portrait 4:5', width: 1080, height: 1350, usage: 'Instagram feed' },
  '16:9': { label: 'Landscape 16:9', width: 1920, height: 1080, usage: 'Facebook / YouTube / OG' },
  '9:16': { label: 'Vertical 9:16', width: 1080, height: 1920, usage: 'TikTok / Reels / Stories' },
};

export function isAspectRatio(value: string): value is AspectRatio {
  return (ASPECT_RATIOS as readonly string[]).includes(value);
}

export function aspectRatioValue(ratio: AspectRatio): number {
  const meta = ASPECT_RATIO_META[ratio];
  return meta.width / meta.height;
}
